import { render, staticRenderFns } from "./CoachingQuestion.vue?vue&type=template&id=32e4005e&scoped=true"
import script from "./CoachingQuestion.vue?vue&type=script&lang=js"
export * from "./CoachingQuestion.vue?vue&type=script&lang=js"
import style0 from "./CoachingQuestion.vue?vue&type=style&index=0&id=32e4005e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4005e",
  null
  
)

export default component.exports